import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from '../../core/services/config/config.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { DashboardSummary } from '../models/dashboard-summary';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;
  private readonly dashboardEndpoint = `${this.config.adminDashboardApiUrl}/AccessManagement/Dashboard`;

  getSummary(): Observable<DashboardSummary> {
    return this.utilityService.getRequest<DashboardSummary>(this.dashboardEndpoint);
  }
}
